import { LAUNCH_OPTIN, LAUNCH_OPTOUT, OPT_OUT_COUNTRIES } from './constants';
import { getCountryCode, getLaunchConsent, getOneTrustAdvertisingConsent } from './signals';

export function getRegionalDefaultConsent(countryCode: string | null): boolean {
  if (!countryCode) return false;
  return !OPT_OUT_COUNTRIES.has(countryCode.toUpperCase());
}

// WEB-207389: fail-closed retargeting gate. Precedence, first definitive answer wins:
// 1) Adobe Launch user_optin_status, 2) OneTrust advertising group, 3) akmCC regional default.
// Evaluate fresh at each call site; consent can change mid-session.
export function canExecuteHomepageRetargeting(): boolean {
  try {
    const launch = getLaunchConsent();
    if (launch === LAUNCH_OPTIN) return true;
    if (launch === LAUNCH_OPTOUT) return false;

    const oneTrust = getOneTrustAdvertisingConsent();
    if (oneTrust !== null) return oneTrust;

    return getRegionalDefaultConsent(getCountryCode());
  } catch {
    return false;
  }
}
